import type { GlsInitResponseData } from './types';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

/** GLS returns resolved launch params on `gameData.directLaunchParams`. */
export const extractDirectLaunchParamsFromGlsData = (
  data: GlsInitResponseData | undefined,
): Record<string, unknown> | null => {
  const fromGameData = data?.gameData?.directLaunchParams;
  return isRecord(fromGameData) ? fromGameData : null;
};
